<div class="conditional__condition-form">
  @if (!isFirstCondition()) {
    <mat-form-field appearance="outline" [subscriptSizing]="'dynamic'">
      <mat-select [(ngModel)]="commandSelected" [ngModelOptions]="{ standalone: true }" aria-label="Pick command">
        <mat-option [value]="'AND'">AND</mat-option>
        <mat-option [value]="'OR'">OR</mat-option>
      </mat-select>
    </mat-form-field>
  }

  @if (!surveyConditionalsService.questionSelected$()) {
    <mat-form-field appearance="outline" [subscriptSizing]="'dynamic'">
      <input
        matInput
        [formControl]="filterCtrl"
        [matAutocomplete]="auto"
        type="text"
        placeholder="Select a previous question"
        aria-label="Select a previous question"
      />
      <mat-autocomplete
        autoActiveFirstOption
        #auto="matAutocomplete"
        class="eiq-no-wrap-option"
        [classList]="'eiq-no-wrap-option'"
        (optionSelected)="onSelectedQuestion($event)"
      >
        @for (prevQuestion of filteredQuestions$ | async; track prevQuestion.id) {
          <mat-option [value]="prevQuestion">{{ prevQuestion.code }} - {{ prevQuestion.title || prevQuestion.variableToken | toPlainText }}</mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>
  } @else {
    <div class="conditional__selected-card">
      <div class="conditional__selected-card-title">
        <div class="eiq-id-badge">
          <fa-icon [icon]="questionTypeConfig[surveyConditionalsService.questionSelected$().type].icon"></fa-icon>
          <span>{{ surveyConditionalsService.questionSelected$().id | qCode }}</span>
        </div>
        <button mat-icon-button title="Clear selected question" class="clear-button" (click)="onClearQuestionSelected()">
          <fa-icon [icon]="faClose"></fa-icon>
        </button>
      </div>
      <span class="conditional__selected-card-text fs__md">{{
        surveyConditionalsService.questionSelected$().title || surveyConditionalsService.questionSelected$().variableToken | toPlainText
      }}</span>
    </div>

    @if (conditionalLogicByQuestionTypeSettings[surveyConditionalsService.questionSelected$().type]; as settings) {
      <ng-container *ngComponentOutlet="settings"></ng-container>
    }

    <empathy-logic-operator-dropdown></empathy-logic-operator-dropdown>

    @if (valuesApplied$()) {
      <empathy-condition-value-view (clearValues)="onClearValuesSelected($event)"></empathy-condition-value-view>
    } @else {
      @if (conditionOperatorFormSettings[surveyConditionalsService.conditionFormValues$().operator]; as settings) {
        <ng-container *ngComponentOutlet="settings"></ng-container>

        @if (surveyConditionalsService.canApplyCondition$()) {
          <button mat-flat-button color="primary" (click)="onApply()">Apply</button>
        }
      }
    }
  }

  <div class="conditional__condition-form-footer">
    @if (invalidCondition$()) {
      <span class="conditional__condition-form-error fs__sm">The condition is not correct. Review it and try again.</span>
    }
    <div class="conditional__condition-form-actions">
      <button mat-stroked-button class="cancel-button" (click)="onCancel()">Cancel</button>
      @if (valuesApplied$()) {
        <button mat-stroked-button color="primary" class="save-button" (click)="onSave()">Apply condition</button>
      }
    </div>
  </div>
</div>
